<!--完成收款弹窗形式 销售 收款 -->
<template>
    <div>
        <el-form :rules="rules" :model="submitData" label-width="120px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="confirmData.OrderType==0 ?'采购总额':'退款总额'">
                            <el-input v-model="allMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="合计总额">
                            <el-input v-model="hjMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item
                            :label="confirmData.OrderType==0 ?'实付金额':'实退金额'"
                            prop="ActualMoney"
                        >
                            <el-input
                                ref="acmoney"
                                type="number"
                                step="1"
                                v-model="submitData.ActualMoney"
                                :min="0"
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select
                                v-model="submitData.PayType"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in payWayList"
                                    :key="item.Value"
                                    :label="item.Text"
                                    :value="item.Value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="grid-content bg-purple">
                        <el-form-item label="备注">
                            <el-input v-model="submitData.Remark"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click="submitForm()"
                :disabled="!canSubmit"
            >提交确认</el-button>
        </div>
    </div>
</template>
<script>
export default {
  name: "",
  props: ["confirmData"],
  components: {},
  data() {
    return {
      allMoney: 0,
      hjMoney: 0,
      payWayList: [],
      submitData: {
        OrderId: "",
        ActualMoney: "",
        PayType: "",
        Remark: ""
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "blur" }],
        ActualMoney: [{ required: true, message: "该项必填", trigger: "blur" }]
      },
      canSubmit: true // 是否可以提交
    };
  },
  mounted() {
    if (this.confirmData) {
      this.allMoney = this.confirmData.OrderAmount.toFixed(2);
      this.hjMoney = (
        this.confirmData.OrderAmount +
        this.confirmData.ShipAmount -
        this.confirmData.DiscountAmount
      ).toFixed(2);
      if (this.confirmData.PayType) {
        this.submitData.PayType = this.confirmData.PayType;
      }
      this.submitData.OrderId = this.confirmData.OrderId;

      this.submitData.ActualMoney = this.hjMoney;
      this.getPay();
    } else {
      this.$util.warningMsg("单据数据异常，请刷新后重新操作");
    }
    if (this.$refs.acmoney) this.$refs.acmoney.focus();
  },
  methods: {
    cancel() {
      this.$emit("closeConfirm");
    },
    submitForm() {
      if (this.submitData.ActualMoney < 0) {
        this.$util.warningMsg("实付金额不能小于0");
        return;
      }
      if (this.submitData.ActualMoney == 0) {
        let title = "";
        title = "实付金额当前等于0，仍确定要提交吗？";

        this.$confirm(title, "提示", {
          confirmButtonText: "确定继续提交",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$refs["submitData"].validate(valid => {
              if (valid) {
                this.canSubmit = false;
                this.$util
                  .axiosPost({
                    url: "/api/RevenueManagement_N/ConfirmDBCheckPurOrders",
                    data: this.submitData
                  })
                  .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$emit("closeConfirm", res.data,this.submitData.ActualMoney);
                  })
                  .catch(() => {
                    this.canSubmit = true;
                  });
              } else {
                return false;
              }
            });
          })
          .catch(() => {});
      } else {
        this.$refs["submitData"].validate(valid => {
          if (valid) {
            this.canSubmit = false;
            this.$util
              .axiosPost({
                url: "/api/RevenueManagement_N/ConfirmDBCheckPurOrders",
                data: this.submitData
              })
              .then(res => {
                this.$util.successMsg(res.errmsg);
                this.$emit("closeConfirm", res.data,this.submitData.ActualMoney);
              })
              .catch(() => {
                this.canSubmit = true;
              });
          } else {
            return false;
          }
        });
      }
    },
    //  结算方式
    getPay() {
      this.$util.getPay().then(data => {
        this.payWayList = data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
